import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataService, UtilityFlightService, XchangeratesService } from 'src/app/services';

@Component({
  selector: 'app-view-multi-fare',
  templateUrl: './view-multi-fare.component.html',
  styleUrls: ['./view-multi-fare.component.scss']
})
export class ViewMultiFareComponent implements OnInit {
  list;
  isMobile: boolean = true;
  currentIndex: number = 0; 
  itemsPerPage: number = 3;
  activeIndex__: number | null = 0; 
  flightsWayto;
  
  constructor(public DATA_UITL: DataService,  public dialogRef: MatDialogRef<ViewMultiFareComponent>, @Inject(MAT_DIALOG_DATA) public data, private uitlFlight: UtilityFlightService,  public Xchangerates: XchangeratesService) { 
    this.list = data; 
  }

  ngOnInit(): void {
    this.flightsWayto = this.uitlFlight.getFlightsByType();
    this.setItemsPerPage();
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }
  
  isObject(value: any): boolean {
    return value && typeof value === 'object' && !Array.isArray(value);
  }
  
  objectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  next(): void {
    if (this.currentIndex + this.itemsPerPage < this.list.multifares.length) {
      this.currentIndex += 1; // Increment index by 1
    }
  }

  previous(): void {
    if (this.currentIndex > 0) {
      this.currentIndex -= 1; // Decrement index by 1
    }
  }

  onMouseEnter(index: number): void {
    this.activeIndex__ = index;
  }
  
  onMouseLeave(): void {
    this.activeIndex__ = 0; // Revert back to the first card when no card is hovered.
  }

  submit(item, item_fare) {
    const BookingConform = {item, item_fare};
    this.dialogRef.close();
    this.dialogRef.close(BookingConform);
  }
  closeDialog(){
    this.dialogRef.close();
  }

  setItemsPerPage() {
    this.itemsPerPage = window.innerWidth <= 540 ? 1 : 3;
  }

  convertToHTML(arr: string[]): string {
    return arr?.join('<br/>') || '';
  }

  getUniqueFaretypes(faretypes: any[]) {
    const map = new Map();
    faretypes?.forEach(ft => {
      if (!map.has(ft.name)) {
        map.set(ft.name, ft);
      }
    });
    return Array.from(map.values());
  }


}
